import React from 'react';
interface SectionDividerProps {
  /** Background tone the divider sits on, so the line/ornament blend correctly. */
  tone?: 'cream' | 'white';
}
/**
 * A hairline horizontal rule with a centered diamond ornament.
 * Used between sections to give the negative space an intentional, "designed" rhythm.
 */
export function SectionDivider({
  tone = 'cream'
}: SectionDividerProps) {
  const bg = tone === 'white' ? 'bg-white' : 'bg-inkova-cream';
  return <div className={`${bg} flex justify-center`} aria-hidden="true" data-id="element-409" data-mp="347y6r3k532iz">
      <div className="flex items-center gap-5 w-full max-w-[1100px] mx-auto px-6" data-id="element-410" data-mp="2zed6f4v2pwgm">
        <span className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-inkova-border" data-id="element-411" data-mp="2ufa8s5hfasio" />
        <span className="w-[7px] h-[7px] rotate-45 border border-inkova-primary/40" data-id="element-412" data-mp="2qf9mjyo31d12" />
        <span className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-inkova-border" data-id="element-413" data-mp="2lfx0hg51c9zj" />
      </div>
    </div>;
}